// extracted by mini-css-extract-plugin
export default {"wrapper":"PopUp_wrapper__v4SPM","container":"PopUp_container__x4xoy","buttonContainer":"PopUp_buttonContainer__9YW4J"};